<table class="table w-full border-separate border-spacing-1">
  <thead>
    <tr>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">Bild</th>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">Name</th>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">NCC</th>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">Klasse</th>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">Hülle</th>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">Schilde</th>
      <th class="px-2 bg-gray-800 border border-gray-700 border-solid text-left">Von</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of tableRows">
      <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">
        <img [src]="row.image" [alt]="row.objectClass" class="mx-auto" />
      </td>
      <td class="px-2 bg-gray-900 border border-gray-800 border-solid" [innerHTML]="row.name | safeHtml"></td>
      <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ row.ncc }}</td>
      <td class="px-2 text-left bg-gray-900 border border-gray-800 border-solid">{{ row.objectClass }}</td>
      <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">{{ row.huell }}</td>
      <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">{{ row.shields }}</td>
      <td class="px-2 bg-gray-900 border border-gray-800 border-solid">
        <a [routerLink]="['/player', row.player.id]" class="hover:text-orange-300">{{ row.player.name }}</a>
      </td>
    </tr>
    <tr *ngIf="tableRows.length === 0">
      <td colspan="7" class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">Keine Objekte in diesem Sektor.</td>
    </tr>
  </tbody>
</table>
